import React, { useState } from "react";
import { Form, Input, Button, Card, message, Upload, Modal } from "antd";
import { FilePdfOutlined, UploadOutlined } from "@ant-design/icons";
import { useParams } from "react-router-dom";
import { applyJobApi } from "../../../apiservice/ats";

const CandidateApplyForm = () => {
  const { id } = useParams(); // job_id
  const [loading, setLoading] = useState(false);

  const [coverLetterList, setCoverLetterList] = useState([]);
  const [resumeList, setResumeList] = useState([]);

  const handleCoverLetterChange = ({ fileList }) => setCoverLetterList(fileList);
  const handleResumeChange = ({ fileList }) => setResumeList(fileList);

  // Handle form submission
  const handleSubmit = async (values) => {
    try {
        setLoading(true); 
        // Create FormData for file upload
        const formData = new FormData();

        // Append all form fields
        Object.entries(values).forEach(([key, value]) => {
            formData.append(key, value);
        });

        if (resumeList.length > 0) {
            formData.append("resume", resumeList[0].originFileObj);
        }

        if (coverLetterList.length > 0) {
            formData.append("cover_letter", coverLetterList[0].originFileObj);
        } 
        if (id) {
            formData.append("job_id", id);
        }

        await applyJobApi(formData);

        // Show confirmation modal
        Modal.info({
            title: "Application Submitted",
            content:
            "Your application has been submitted successfully. Click OK to close this tab.",
            onOk: () => {
            window.close(); // try to close tab
            },
            okText: "Close Tab",
        });
    } catch (err) {
      // Extract error message from API response
      const errorMsg =
        err?.response?.data?.error ||
        err?.message ||
        "Failed to submit application";

      message.error(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  // File validation before upload
  const beforeUpload = (file, setter) => {
    const allowedTypes = [
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    ];

    if (!allowedTypes.includes(file.type)) {
      message.error("Only PDF, DOC, DOCX files are allowed.");
      return Upload.LIST_IGNORE;
    }

    setter(file);
    return false; // prevent auto upload
  };

  return (
    <Card title="Apply for this Job" style={{ maxWidth: 600, margin: "40px auto" }}>
      <Form layout="vertical" onFinish={handleSubmit}>
        <Form.Item label="Full Name" name="name" rules={[{ required: true }]}>
          <Input />
        </Form.Item>

        <Form.Item label="Email" name="email" rules={[{ required: true }]}>
          <Input type="email" />
        </Form.Item>

        <Form.Item label="Phone" name="phone" rules={[{ required: true }]}>
          <Input />
        </Form.Item>

        <Form.Item label="Experience" name="experience">
          <Input.TextArea rows={4} />
        </Form.Item> 

        {/* Resume Upload */}
        <Form.Item label="Resume">
          <Upload
            beforeUpload={() => false} // prevent auto upload
            fileList={resumeList}
            onChange={handleResumeChange}
            accept=".pdf,.doc,.docx"
            maxCount={1}
          >
            <Button icon={<FilePdfOutlined />}>Upload Resume</Button>
          </Upload>
        </Form.Item>

        {/* Cover letter Upload */}
        <Form.Item label="Photo">
          <Upload
            beforeUpload={() => false} // prevent auto upload
            fileList={coverLetterList}
            onChange={handleCoverLetterChange}
            accept="image/*"
            maxCount={1}
          >
            <Button icon={<UploadOutlined />}>Upload Cover Letter</Button>
          </Upload> 
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit" loading={loading}>
            Submit Application
          </Button>
        </Form.Item>
      </Form>
    </Card>
  );
};

export default CandidateApplyForm;
